import Routes from "@navigations/Routes";
import { isEmbeddedFrame, postIframeLayout } from "@utils/iframeMessaging";
import { measureActiveContentHeight } from "./contentBounds";

// A gemstone section pads a few pixels under its last row. That has to reach
// the parent, or the iframe stays short and the page keeps an inner scroll.
const MIN_CHANGE = 2;

export const initializePdpHeight = () => {
  if (!isEmbeddedFrame()) return () => undefined;

  let active = true;
  let lastPosted = 0;
  let frameId = 0;
  let timer = 0;

  const publish = () => {
    if (!active) return;
    const height = measureActiveContentHeight();
    if (height <= 0 || Math.abs(height - lastPosted) < MIN_CHANGE) return;
    lastPosted = height;
    postIframeLayout({
      mode: "auto-height",
      route: Routes.PDPScreen,
      height,
    });
  };

  const schedule = () => {
    cancelAnimationFrame(frameId);
    window.clearTimeout(timer);
    frameId = requestAnimationFrame(() => {
      timer = window.setTimeout(publish, 300);
    });
  };

  const observer = new MutationObserver(schedule);
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  }
  window.addEventListener("resize", schedule);
  schedule();

  return () => {
    active = false;
    cancelAnimationFrame(frameId);
    window.clearTimeout(timer);
    observer.disconnect();
    window.removeEventListener("resize", schedule);
  };
};

export const cleanupPdpHeight = (cleanup: () => void) => cleanup();
